export default __webpack_public_path__ + "6b660cdd19e4a547570277127342a9a9.glb";